import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexRow, IconButton } from "@similarweb/ui-components";

const { carbon, red } = colorsPalettes;

export const AlertIndicationContainer = styled(FlexRow)`
    width: 13.5%;
    min-width: max-content;
    align-items: center;
    justify-content: end;
`;

export const AlertsButton = styled(IconButton).attrs({
    type: "flat",
    className: "alertsIndicationButton",
})`
    .SWReactIcons svg g path {
        &:first-child {
            fill: ${red["s100"]};
        }
        &:last-child {
            fill: ${carbon[0]};
        }
    }
`;

const AlertsButtonIcon = styled.div``;
